module.exports = __webpack_public_path__ + "static/4BHK-07-Bedroom-03-ebd3e7723de5b9950ac0bd6e5e200f0d.jpg";